<template>
  <div class="productCenterDetails">
    <!-- 内容 -->
    <div class="content-box">
      <div class="content-box-center">
        <div class="left">
          <div class="top-img">
            <el-carousel indicator-position="none" arrow="nerver" style="width:100%">
              <el-carousel-item v-for="(item,index) in detailInfo.slideShow" :key="index">
                <img :src="item.url" alt="" />
              </el-carousel-item>
            </el-carousel>
            
          </div>
          <div class="bottom-btn">
            <div v-show="detailInfo.prevProductId>0" @click="detailsFun(detailInfo.prevProductId)">上一款产品</div>
            <div v-show="detailInfo.nextProductId>0" @click="detailsFun(detailInfo.nextProductId)">下一款产品</div>
          </div>
        </div>
        <div class="right">
          <div class="name">{{detailInfo.name}}</div>
          <div style="font-size: 15px;
          padding-top: 6px;
          color: #999;">价格：<span style="color:red;font-size: 20px;">{{detailInfo.product_price}}</span></div>
          <div class="biaoti">
            <div>产品特点/Product features</div>
            <img src="../assets/Line.png" alt="" />
          </div>
          <div class="jianjie">{{detailInfo.specialty}}</div>
          <div class="biaoti">
            <div>产品说明/Product description</div>
            <img src="../assets/Line.png" alt="" />
          </div>
          <div class="jianjie">产品代码：{{detailInfo.code}}, 工艺说明：{{detailInfo.description}}</div>
          <div class="biaoti">
            <div>配件展示/Accessories display</div>
            <img src="../assets/Line.png" alt="" />
          </div>
          <div class="peijian">
            <img :src="item.url" alt="" v-for="(item,index) in detailInfo.fittings" :key="index" />
          </div>
          <div class="biaoti">
            <div>颜色参考/Color reference</div>
            <img src="../assets/Line.png" alt="" />
          </div>
          <div class="yanse">
            <div>
              <img :src="item.url" alt="" v-for="(item,index) in detailInfo.colors" :key="index" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { productInfo } from "@/request/api";
export default {
  name: "ProductCenterDetails",
  data() {
    return {
      detailInfo: {}, //详情
    };
  },
  created() {
    this.productInfoFun(this.$route.query.id);
  },
  methods: {
    // 获取详情
    productInfoFun(id) {
      productInfo({ productId: id }).then((res) => {
        if (res.data.code == 10000) {
          this.detailInfo = res.data.data;
          if (res.data.data.title_str) {
            document.title = res.data.data.title_str;
          }
          if (res.data.data.key_str) {
            document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.data.key_str);
          }
          if (res.data.data.describe_str) {
            document.querySelector('meta[name="description"]').setAttribute('content', res.data.data.describe_str);
          }
          console.log(res);
        }
      });
    },
    // 点击上下产品
    detailsFun(id) {
      this.$router.push("/productCenter/productCenterDetails?id=" + id);
      this.productInfoFun(this.$route.query.id);
    }
  },
};
</script>

<style scoped lang="less">
@import "../css/productCenterDetails.less";
</style>
